var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "newsletterForm",
      staticClass: "newsletterInputForm",
      attrs: { id: "newsletter-input-form_" + _vm._uid, method: "post" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.validateData($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "row",
          staticStyle: { "flex-direction": "row-reverse" }
        },
        [
          _vm.showNameInputs
            ? _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "input-unit",
                    attrs: { "data-validate": "!regex" }
                  },
                  [
                    _c(
                      "label",
                      { attrs: { for: "first-name-input_" + _vm._uid } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.newsletterFirstName"
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.firstName,
                          expression: "firstName"
                        }
                      ],
                      attrs: {
                        type: "text",
                        "data-validate-ref": "/[.:\\/\\d]/g",
                        id: "first-name-input_" + _vm._uid,
                        "data-testing": "nl-first-name"
                      },
                      domProps: { value: _vm.firstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.firstName = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showNameInputs
            ? _c("div", { staticClass: "col-6 pl-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "input-unit",
                    attrs: { "data-validate": "!regex" }
                  },
                  [
                    _c(
                      "label",
                      { attrs: { for: "last-name-input_" + _vm._uid } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.newsletterLastName")
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lastName,
                          expression: "lastName"
                        }
                      ],
                      attrs: {
                        type: "text",
                        "data-validate-ref": "/[.:\\/\\d]/g",
                        id: "last-name-input_" + _vm._uid,
                        "data-testing": "nl-last-name"
                      },
                      domProps: { value: _vm.lastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.lastName = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "input-group" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit newsletter-input",
                  attrs: { "data-validate": "mail" }
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "email-input-id_" + _vm._uid } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "ETCeresCoconut::Template.etcNewsletterEMailText"
                          )
                        ) +
                          " " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.newsletterIsRequiredFootnote"
                            )
                          )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    attrs: {
                      type: "email",
                      autocomplete: "email",
                      id: "email-input-id_" + _vm._uid,
                      "data-testing": "nl-mail"
                    },
                    domProps: { value: _vm.email },
                    on: {
                      focus: function($event) {
                        _vm.loadRecaptcha = true
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.honeypot,
                    expression: "honeypot"
                  }
                ],
                staticClass: "honey",
                attrs: {
                  autocomplete: "none",
                  type: "text",
                  name: "username",
                  tabindex: "-1"
                },
                domProps: { value: _vm.honeypot },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.honeypot = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _vm.showPrivacyPolicyCheckbox
            ? _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-check small newsletter-datenschutz",
                    attrs: { "data-validate": "" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.privacyPolicyValue,
                          expression: "privacyPolicyValue"
                        }
                      ],
                      staticClass: "form-check-input",
                      staticStyle: { height: "unset" },
                      attrs: {
                        type: "checkbox",
                        id: "privacy-policy-accept-id_" + _vm._uid,
                        name: "privacy-policy-accept",
                        "data-testing": "nl-policy"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.privacyPolicyValue)
                          ? _vm._i(_vm.privacyPolicyValue, null) > -1
                          : _vm.privacyPolicyValue
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.privacyPolicyValue,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.privacyPolicyValue = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.privacyPolicyValue = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.privacyPolicyValue = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      staticClass: "form-check-label",
                      attrs: { for: "privacy-policy-accept-id_" + _vm._uid },
                      domProps: { innerHTML: _vm._s(_vm.privacyPolicyText) }
                    })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-9 col-12 newsletter-button" }, [
            _c("div", { staticClass: "input-group-btn" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-block btn-secondary btn-appearance",
                  class: _vm.buttonSizeClass,
                  attrs: {
                    type: "button",
                    disabled: _vm.isDisabled,
                    "data-testing": "nl-send"
                  },
                  on: { click: _vm.validateData }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$translate(
                          "ETCeresCoconut::Template.etcNewsletterButtonAboText"
                        )
                      ) +
                      "\n          "
                  ),
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "15",
                        viewBox: "0 0 20 15"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "envelope-solid",
                          d:
                            "M19.621,68.953a.235.235,0,0,1,.379.184v7.988A1.875,1.875,0,0,1,18.125,79H1.875A1.875,1.875,0,0,1,0,77.125V69.141a.234.234,0,0,1,.379-.184c.875.68,2.035,1.543,6.02,4.438.824.6,2.215,1.867,3.6,1.859,1.395.012,2.813-1.281,3.605-1.859C17.59,70.5,18.746,69.633,19.621,68.953ZM10,74c.906.016,2.211-1.141,2.867-1.617,5.184-3.762,5.578-4.09,6.773-5.027A.935.935,0,0,0,20,66.617v-.742A1.875,1.875,0,0,0,18.125,64H1.875A1.875,1.875,0,0,0,0,65.875v.742a.94.94,0,0,0,.359.738c1.2.934,1.59,1.266,6.773,5.027C7.789,72.859,9.094,74.016,10,74Z",
                          transform: "translate(0 -64)",
                          fill: "#fff"
                        }
                      })
                    ]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 text-right small mt-2" }, [
            _vm._v(
              _vm._s(
                _vm.$translate("Ceres::Template.newsletterIsRequiredFootnote")
              ) +
                " " +
                _vm._s(_vm.$translate("Ceres::Template.newsletterIsRequired"))
            )
          ])
        ]
      ),
      _vm._v(" "),
      !!_vm.$ceres.config.global.googleRecaptchaApiKey && _vm.loadRecaptcha
        ? _c("recaptcha")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }